"use client";

import Link from "next/link";
import { usePathname, useRouter } from "next/navigation";

const NAV = [
  { href: "/", label: "대시보드", icon: "📊" },
  { href: "/accounts", label: "계정 관리", icon: "👤" },
  { href: "/proxies", label: "프록시", icon: "🌐" },
  { href: "/personas", label: "페르소나", icon: "🎭" },
  { href: "/activity", label: "일상 활동", icon: "🌱" },
  { href: "/feed", label: "활동 피드", icon: "📸" },
  { href: "/campaigns", label: "캠페인", icon: "🚀" },
];

export function Sidebar() {
  const pathname = usePathname();
  const router = useRouter();

  // 로그인 페이지에서는 사이드바 없음
  if (pathname === "/login") return null;

  async function logout() {
    await fetch("/api/auth/logout", { method: "POST" });
    router.push("/login");
    router.refresh();
  }

  return (
    <aside className="w-56 shrink-0 border-r border-black/10 dark:border-white/10 p-4 flex flex-col gap-1">
      <div className="px-3 py-4 mb-2">
        <div className="text-lg font-bold tracking-tight">VIRAS</div>
        <div className="text-xs opacity-60">Reddit 마케팅</div>
      </div>
      {NAV.map((item) => (
        <Link
          key={item.href}
          href={item.href}
          className={`flex items-center gap-2 px-3 py-2 rounded-lg text-sm hover:bg-black/5 dark:hover:bg-white/10 transition-colors ${
            pathname === item.href ? "bg-black/5 dark:bg-white/10 font-medium" : ""
          }`}
        >
          <span>{item.icon}</span>
          <span>{item.label}</span>
        </Link>
      ))}
      <div className="mt-auto flex items-center justify-between px-3 py-2">
        <span className="text-xs opacity-40">v0.1 · dev</span>
        <button
          onClick={logout}
          className="text-xs opacity-60 hover:opacity-100 hover:underline"
        >
          로그아웃
        </button>
      </div>
    </aside>
  );
}
